import { orderBy } from 'lodash';
import React from 'react';

import { CharacterTheme, Extra, ExtraUtils } from '@dndbeyond/character-rules-engine/es';

import ExtraRow from '../ExtraRow';

interface Props {
    extras: Array<Extra>;
    showNotes: boolean;
    onShow?: (extra: Extra) => void;
    onStatusChange?: (extra: Extra, newStatus: boolean) => void;
    isReadonly: boolean;
    theme: CharacterTheme;
}
export default class ExtraList extends React.PureComponent<Props, {}> {
    static defaultProps = {
        showNotes: true,
        isReadonly: false,
    };

    render() {
        const { extras, showNotes, onShow, onStatusChange, isReadonly, theme } = this.props;

        let orderedExtras: Array<Extra> = orderBy(extras, (extra) => ExtraUtils.getName(extra));

        return (
            <div className="ct-extra-list">
                <div className="ct-extra-list__row-header">
                    <div className="ct-extra-list__col ct-extra-list__col--preview" />
                    <div className="ct-extra-list__col ct-extra-list__col--primary">Name</div>
                    <div className="ct-extra-list__col ct-extra-list__col--ac">AC</div>
                    <div className="ct-extra-list__col ct-extra-list__col--hp">Hit Points</div>
                    <div className="ct-extra-list__col ct-extra-list__col--speed">Speed</div>
                    {showNotes && <div className="ct-extra-list__col ct-extra-list__col--notes">Notes</div>}
                </div>
                <div className="ct-extra-list__items">
                    {orderedExtras.map((extra) => (
                        <ExtraRow
                            theme={theme}
                            key={ExtraUtils.getUniqueKey(extra)}
                            extra={extra}
                            onShow={onShow}
                            onStatusChange={onStatusChange}
                            showNotes={showNotes}
                            isReadonly={isReadonly}
                        />
                    ))}
                </div>
            </div>
        );
    }
}
